import { render, staticRenderFns } from "./EmailValidate.vue?vue&type=template&id=57685142&scoped=true&"
import script from "./EmailValidate.vue?vue&type=script&lang=js&"
export * from "./EmailValidate.vue?vue&type=script&lang=js&"
import style0 from "./EmailValidate.vue?vue&type=style&index=0&id=57685142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57685142",
  null
  
)

export default component.exports